// utils/devNotice.js

/**
 * Fungsi untuk menampilkan notifikasi atau log bahwa halaman masih dalam pengembangan.
 * Dapat digunakan di level komponen atau routing.
 */

export const showDevNotice = (pageName = "This page") => {
  if (process.env.NODE_ENV === "development") {
    console.info(
      `%c⚠️ ${pageName} is still under development.`,
      "color: #ff9800; font-weight: bold;"
    );
  }
};

/**
 * Komponen kecil untuk menampilkan banner di UI
 */
export const DevBanner = ({ message = "This page is under development." }) => {
  const bannerStyle = {
    backgroundColor: "#FFF3CD",
    color: "#856404",
    padding: "10px 16px",
    borderRadius: "6px",
    border: "1px solid #FFEEBA",
    fontSize: "14px",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  return (
    <div style={bannerStyle}>
      <span role="img" aria-label="warning">
        🚧
      </span>
      <span>{message}</span>
    </div>
  );
};

// Development status utilities
export const DEVELOPMENT_STATUS = {
  // General development messages
  UNDER_DEVELOPMENT: "This feature is currently under development",
  API_NOT_READY: "API integration is not yet implemented",
  COMING_SOON: "This functionality will be available soon",

  // Specific module messages
  HR_MODULE: {
    TEAM_MANAGEMENT: "Team management module is under development",
    IDCARD_MANAGEMENT: "ID Card management module is under development",
    SALARY_MANAGEMENT: "Salary management module is under development",
    ATTENDANCE_MANAGEMENT: "Attendance management module is under development",
  },

  // Data source information
  DATA_SOURCE: {
    DUMMY_DATA: "Currently using dummy data for demonstration",
    API_INTEGRATION: "API integration pending",
    MOCK_DATA: "Using mock data until backend is ready",
  },

  // Feature status
  FEATURES: {
    CRUD_OPERATIONS: "CRUD operations are simulated",
    FILE_UPLOAD: "File upload functionality is under development",
    SEARCH_FILTER: "Search and filter features are implemented with dummy data",
    PAGINATION: "Pagination is working with local data",
  },
};

// Helper function to get development status message
export const getDevelopmentStatus = (module, feature) => {
  if (module && feature) {
    return (
      DEVELOPMENT_STATUS[module]?.[feature] ||
      DEVELOPMENT_STATUS.UNDER_DEVELOPMENT
    );
  }
  return DEVELOPMENT_STATUS.UNDER_DEVELOPMENT;
};

// Helper function to check if feature is ready
export const isFeatureReady = (feature) => {
  // This could be expanded to check actual feature flags or environment variables
  return false; // For now, assume nothing is ready
};

// Helper function to get appropriate data source message
export const getDataSourceMessage = () => {
  return DEVELOPMENT_STATUS.DATA_SOURCE.DUMMY_DATA;
};

// Helper function to show development banner
export const getDevelopmentBanner = (moduleName = "This module") => {
  return (
    <div
      className="alert alert-warning alert-dismissible fade show"
      role="alert"
    >
      <span role="img" aria-label="warning">
        🚧
      </span>
      <strong> Development Mode:</strong> {moduleName} is currently using dummy
      data. Full functionality will be available once API integration is
      complete.
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
  );
};
